import { Component, ElementRef, ViewChild } from '@angular/core';
import { LayoutService } from 'src/app/layout/service/app.layout.service';
import { AuthenticationService } from '../its/services/authentication.service';
import { AuthorityService } from '../its/services/authority.service';
import { EnteUO } from '../its/models/EnteUO';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html'
})
export class AppTopbarComponent {

    @ViewChild('menubutton') menuButton!: ElementRef;

    constructor(
                public layoutService: LayoutService,
                private authenticationService: AuthenticationService,
                private authorityService: AuthorityService
                ) { }

    userInfo: any;        
    rolesString: string = "";  

    enteUOInfo: EnteUO;

    ngOnInit() {
        //alert("oninit Topbar");
        // informazioni utente
        this.userInfo = this.authenticationService.getUserValue;
        for(let i=0; i<this.authenticationService.getUserValue.roles.length; i++){
            this.rolesString = this.rolesString + " " + this.authenticationService.getUserValue.roles[i];
        }

        // recupero i dati Ente / UO
        this.authorityService.enteUOData$.subscribe(data => {
            this.enteUOInfo = data;
        });
        //console.log(this.enteUOInfo);
    }

    onMenuButtonClick() {
        this.layoutService.onMenuToggle();
    }

    onProfileButtonClick() {
        this.layoutService.showProfileSidebar();        
    }
    
}